import { post } from 'utils/api';

export const sendContactEmail = (data) => {
  return post(`/util/sendemail`, data);
};

export const util = {
  sendContactEmail,
};
